import { ProductsPageStates } from '../../../typings/products';

export const UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS = 'UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS';
export type UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS = typeof UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS;

export interface UpdateInternalProductsPageStatus {
    type: UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS;
    status: ProductsPageStates;
}

export function updateInternalProductsPageStatusAction(status: ProductsPageStates): UpdateInternalProductsPageStatus {
    return {
        type: UPDATE_INTERNAL_PRODUCTS_PAGE_STATUS,
        status
    };
}
